<template>
    <locations-show-page parent v-slot:default="_parent">
        <sub-item-show-view v-slot:default="_">
            <location-assignment-edit-form :disabled="_.itemDisabled" v-model="_.item" :parent-model="_parent.item" />
        </sub-item-show-view>
    </locations-show-page>
</template>

<script>
    import LocationsShowPage from '../../show'
    import SubItemShowView from '../../../../Item/Views/SubItemShowView'
    import LocationAssignmentEditForm from './Shared/LocationAssignmentEditForm'

    export default {
        name: 'LocationsShowAssignmentsEditPage',
        inheritAttrs: false,
        components: {
            LocationsShowPage,
            SubItemShowView,
            LocationAssignmentEditForm,
        },
    }
</script>

<style scoped>

</style>